var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7299 18.3339C24.499 19.6669 23.5336 21.3333 21.9975 21.3333H2.00226C0.46322 21.3333 -0.497696 19.6644 0.269887 18.3339L10.2676 0.999374C11.0371 -0.334333 12.9643 -0.331916 13.7324 0.999374L23.7299 18.3339ZM12 14.75C10.9415 14.75 10.0833 15.6081 10.0833 16.6666C10.0833 17.7252 10.9415 18.5833 12 18.5833C13.0585 18.5833 13.9167 17.7252 13.9167 16.6666C13.9167 15.6081 13.0585 14.75 12 14.75ZM10.1803 7.86057L10.4894 13.5272C10.5038 13.7924 10.7231 14 10.9886 14H13.0114C13.2769 14 13.4962 13.7924 13.5106 13.5272L13.8197 7.86057C13.8353 7.57416 13.6073 7.33332 13.3205 7.33332H10.6795C10.3927 7.33332 10.1647 7.57416 10.1803 7.86057Z",
    fill: "#BD4F00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.bcb5c28e110f21b629fd88e2ba32e585.svg";
export { ForwardRef as ReactComponent };